import React from 'react';
import PackageSearchGridItem from '../house-and-land/elements/PackageSearchGridItem';


const SimilarPackageGrid = (props) => {
    let label = props.label;
    if(props.data.length === 0) { label = ''; }
    return (
        <div className="cf m-b-3-lg m-b-1">
            <div className="w-100 land-search-grid">
                <p className="m-b-0 p-a-1 release-title tc tl-md">{label}</p>
                <div className="cf m-b-2">
                    {props.data.map((thisPackage) =>
                        <PackageSearchGridItem key={thisPackage.id} data={thisPackage} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default SimilarPackageGrid;


/** WEBPACK FOOTER **
 ** ./src/modules/common/SimilarPackageGrid.js
 **/